/* ============================================================
   Piave · Galeria Antes x Depois
   <before-after-item>: slider de comparacao acessivel.
   - pointer events (mouse + toque) via getBoundingClientRect
     (funciona dentro de carrossel com scroll horizontal)
   - teclado: setas, Home/End (role="slider")
   - clique posiciona a alca
   ============================================================ */
(function () {
  if (customElements.get('before-after-item')) return;

  class BeforeAfterItem extends HTMLElement {
    connectedCallback() {
      this.pos = parseFloat(this.getAttribute('data-start')) || 50;
      this.dragging = false;
      this._apply(this.pos);

      this.addEventListener('pointerdown', this._down.bind(this));
      this.addEventListener('pointermove', this._move.bind(this));
      this.addEventListener('pointerup', this._up.bind(this));
      this.addEventListener('pointercancel', this._up.bind(this));
      this.addEventListener('keydown', this._key.bind(this));

      // dica de interacao na primeira vez que aparece
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('ba-hint');
              setTimeout(function () { e.target.classList.remove('ba-hint'); }, 1300);
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.35 });
        io.observe(this);
      }
    }

    _pct(clientX) {
      var r = this.getBoundingClientRect();
      if (!r.width) return this.pos;
      return Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
    }

    _down(e) {
      // ignora o botao secundario
      if (e.button && e.button !== 0) return;
      this.dragging = true;
      this.classList.add('is-dragging');
      this.classList.remove('ba-hint');
      try { this.setPointerCapture(e.pointerId); } catch (err) {}
      this._apply(this._pct(e.clientX));
    }

    _move(e) {
      if (!this.dragging) return;
      e.preventDefault();
      this._apply(this._pct(e.clientX));
    }

    _up(e) {
      if (!this.dragging) return;
      this.dragging = false;
      this.classList.remove('is-dragging');
      try { this.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    _key(e) {
      var step = e.shiftKey ? 10 : 2;
      var p = this.pos;
      switch (e.key) {
        case 'ArrowLeft': case 'ArrowDown': p = this.pos - step; break;
        case 'ArrowRight': case 'ArrowUp': p = this.pos + step; break;
        case 'Home': p = 0; break;
        case 'End': p = 100; break;
        default: return;
      }
      e.preventDefault();
      this._apply(Math.max(0, Math.min(100, p)));
    }

    _apply(pct) {
      this.pos = pct;
      this.style.setProperty('--ba-pos', pct + '%');
      this.setAttribute('aria-valuenow', Math.round(pct));
    }
  }

  customElements.define('before-after-item', BeforeAfterItem);

  /* setas do carrossel (delegado por secao) */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.ba-gallery__arrow');
    if (!arrow) return;
    var gallery = arrow.closest('.ba-gallery');
    var track = gallery && gallery.querySelector('.ba-gallery__track');
    if (!track) return;
    var card = track.querySelector('.ba-card');
    var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    track.scrollBy({ left: arrow.dataset.dir === 'prev' ? -amount : amount, behavior: 'smooth' });
  });
})();
